var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"group-contacts","fluid":"","tag":"section"}},[_c('manage-ehr-patients')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }